import inputTypes from './InputTypes.js';
const _50 = 50;
const _75 = 75;
const inputsToSpeechSensitivity = new Map();

inputsToSpeechSensitivity.set(inputTypes.DIGITS, _75);
inputsToSpeechSensitivity.set(inputTypes.DATE, _50);
inputsToSpeechSensitivity.set(inputTypes.CVV, _75);
inputsToSpeechSensitivity.set(inputTypes.PHONE_CAPTURE, _75);
inputsToSpeechSensitivity.set(inputTypes.ZIP_CAPTURE, _75);

inputsToSpeechSensitivity.set(inputTypes.SSN_CAPTURE, _75);
inputsToSpeechSensitivity.set(inputTypes.CREDIT_CARD_CAPTURE, _75);
inputsToSpeechSensitivity.set(inputTypes.CC_EXPIRATION_DATE, _50);
inputsToSpeechSensitivity.set(inputTypes.ALPHANUMERIC_CAPTURE, _50);
inputsToSpeechSensitivity.set(inputTypes.BANK_ROUTING_NUMBER, _75);

inputsToSpeechSensitivity.set(inputTypes.POSTAL_CODE_CAPTURE, _75);
inputsToSpeechSensitivity.set(inputTypes.DOB_CAPTURE, _50);
inputsToSpeechSensitivity.set(inputTypes.FUTURE_DATE_CAPTURE, _50);
inputsToSpeechSensitivity.set(inputTypes.TIME_OF_DAY_CAPTURE, _50);
inputsToSpeechSensitivity.set(inputTypes.YN_GENERIC, _75);

inputsToSpeechSensitivity.set(inputTypes.DIGIT_CAPTURE, _75);
inputsToSpeechSensitivity.set(inputTypes.NUMBER_CAPTURE, _75);
inputsToSpeechSensitivity.set(inputTypes.DYNAMIC_MATCHING, _50);
inputsToSpeechSensitivity.set(inputTypes.EMAIL_CAPTURE, _50);
inputsToSpeechSensitivity.set(inputTypes.ADDRESS_CAPTURE, _50);

inputsToSpeechSensitivity.set(inputTypes.FIRST_NAME_CAPTURE, _50);
inputsToSpeechSensitivity.set(inputTypes.LAST_NAME_CAPTURE, _50);
inputsToSpeechSensitivity.set(inputTypes.CURRENCY_CAPTURE, _50);
inputsToSpeechSensitivity.set(inputTypes.SIMPLE_CHOICE, _50);
inputsToSpeechSensitivity.set(inputTypes.NONE, _50);

export default inputsToSpeechSensitivity;